import './main.css';

// eslint-disable-next-line import/dynamic-import-chunkname
import('./app');
export {};
